// photogalery (dimbox) – knihovna se načítá jen na stránkách kde je potřeba
if (typeof dimbox !== 'undefined' && dimbox && typeof dimbox.setConfig === 'function') {
    dimbox.setConfig({
        showDownloadButton: false,
        showFullscreenButton: false
    });
}

// scroll down header + plynulé zmenšení výšky hlavičky na desktopu
(function () {
    var header = document.querySelector('.site-header');
    if (!header) return;

    var rafId = null;
    var rootStyle = window.getComputedStyle(document.documentElement);

    function readCssPxVar(name, fallbackPx) {
        var raw = (rootStyle.getPropertyValue(name) || '').trim();
        if (!raw) return fallbackPx;
        var n = parseFloat(raw);
        return Number.isFinite(n) ? n : fallbackPx;
    }

    function refreshRootStyle() {
        rootStyle = window.getComputedStyle(document.documentElement);
    }

    var logoImg = header.querySelector('.navbar-brand img');

    function clamp(n, min, max) {
        return Math.max(min, Math.min(max, n));
    }

    function isDesktop() {
        return window.matchMedia && window.matchMedia('(min-width: 992px)').matches;
    }

    function computeHeight() {
        var desktopMax = readCssPxVar('--header-height-desktop', 150);
        var minH = readCssPxVar('--header-height-min', readCssPxVar('--header-height-mobile', 80));
        var shrinkDist = readCssPxVar('--header-shrink-distance', 200);

        if (!isDesktop()) return Math.round(minH);
        var progress = clamp(window.scrollY / Math.max(1, shrinkDist), 0, 1);
        return Math.round(desktopMax - (desktopMax - minH) * progress);
    }

    function apply() {
        rafId = null;
        refreshRootStyle();

        // Na mobilu nesmíme hlavičku "zamknout" výškou – jinak se nerozbaluje mobilní menu (collapse).
        if (!isDesktop()) {
            header.style.height = '';
            if (logoImg) logoImg.style.maxWidth = '';
        } else {
            var h = computeHeight();
            header.style.height = h + 'px';
            if (logoImg) logoImg.style.maxWidth = h + 'px';
        }

        if (window.scrollY > 50) {
            header.classList.add('scroll-down');
        } else {
            header.classList.remove('scroll-down');
        }
    }

    function schedule() {
        if (rafId) return;
        rafId = window.requestAnimationFrame(apply);
    }

    // init + listeners
    apply();
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
})();

// Kotvy na stránce: posun scrollu o výšku fixní hlavičky (obsah nezůstane pod headerem)
(function () {
    function headerOffsetPx() {
        var header = document.querySelector('.site-header');
        return header ? header.offsetHeight : 0;
    }

    function scrollToHashTarget() {
        var hash = window.location.hash;
        if (!hash || hash.length < 2 || hash === '#') return;
        var id = decodeURIComponent(hash.slice(1));
        if (!id) return;
        var el = document.getElementById(id);
        if (!el) return;
        var top = el.getBoundingClientRect().top + window.scrollY - headerOffsetPx();
        window.scrollTo(0, Math.max(0, top));
    }

    function runAfterLayout() {
        scrollToHashTarget();
        window.requestAnimationFrame(scrollToHashTarget);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', runAfterLayout);
    } else {
        runAfterLayout();
    }

    window.addEventListener('hashchange', scrollToHashTarget);
})();

